import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-line-chart-line',
      title: 'Cash Flow Coach',
      description:
        'Get real-time visibility into your cash position with our proprietary 13-week cash flow forecast model.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Business Turnaround',
      description:
        'Structured turnaround solutions delivered on a fixed fee and fixed timeline to stabilize and revive your business.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fiduciary Services',
      description:
        'Trusted representation as receiver, trustee, or fiduciary in complex financial and legal situations.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Litigation Consulting',
      description:
        'Expert witness testimony and consulting for business disputes, fraud investigations, and financial litigation.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Capital Solutions',
      description:
        'Strategic guidance to secure financing, restructure debt, and optimize your capital structure.',
    },
    {
      icon: 'ri-user-star-line',
      title: 'CXO Services',
      description:
        'Interim executive leadership to guide your business through transition, crisis, or transformation.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-6">
            Our Services
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            We offer a comprehensive suite of turnaround and advisory services
            designed to help distressed businesses stabilize, recover, and
            thrive.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all border-2 border-transparent hover:border-teal-500 flex flex-col"
            >
              <div className="w-16 h-16 bg-teal-500 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow">
                {service.description}
              </p>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:gap-3 transition-all cursor-pointer mt-auto"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}